export default __webpack_public_path__ + "static/media/services3.c14b892e.jpg";